<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "FreeeCallback",
  components: {
  },
  mixins: [],
  props: {
    provider: {
      type: String,
      default: null,
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState("DriverProviderSetting", {
      state: "state",
    }),
    ...mapGetters("DriverProviderSetting", [
      "isConfigured",
    ])
  },
  watch: {

  },

  /**
   * 許可しないが選択された場合以下のレスポンスが返却される.
   * リソースオーナーもしくは認可サーバがリクエストを拒否しました。
   *
   * http://localhost:8081/driver/providers/freee/callback?error=access_denied&error_description=%E3%83%AA%E3%82%BD%E3%83%BC%E3%82%B9%E3%82%AA%E3%83%BC%E3%83%8A%E3%83%BC%E3%82%82%E3%81%97%E3%81%8F%E3%81%AF%E8%AA%8D%E5%8F%AF%E3%82%B5%E3%83%BC%E3%83%90%E3%81%8C%E3%83%AA%E3%82%AF%E3%82%A8%E3%82%B9%E3%83%88%E3%82%92%E6%8B%92%E5%90%A6%E3%81%97%E3%81%BE%E3%81%97%E3%81%9F%E3%80%82&state=9enpez4lnawj5qw58dpf
   * http://localhost:8081/driver/providers/freee/callback
   * ?error=access_denied
   * &error_description=リソースオーナーもしくは認可サーバがリクエストを拒否しました。
   * &state=9enpez4lnawj5qw58dpf
   * {
   *     "error": "access_denied",
   *     "error_description": "リソースオーナーもしくは認可サーバがリクエストを拒否しました。",
   *     "state": "3q4cr1jnkatj859h275q"
   * }
   */
  created() {
    const query = this.$route.query

    if (query.error) {
      /**
       * パラメータにerrorが設定されている場合
       * freeeの許可画面にて「許可しない」が選択された
       */
      this.$router.push({name: 'DriverMasterTenant', query: { error: query.error }})
      return false
    }

    if (query.code && query.state) {
      if (this.state !== query.state) {
        this.release()
        this.$router.push({name: 'DriverMasterTenant', query: {  error: "state_mismatch" }})
        return false
      }
      this.release()
      const params = {
        code: query.code,
      }
      this.startCollaboration({provider: this.provider, params: params}).then((data) => {
        /**
         * レスポンスにより処理を振り分ける
         * message: not_acceptable => [エラー] freee請求連携が有効でない => 契約詳細に遷移
         * message: no_company => [エラー] 所属する事業所が取得できなかった => 契約詳細に遷移
         * message: many_companies => [成功] 複数の事業所に所属 => 事業所選択画面に遷移
         * code: null => [成功] 単一事業所に所属 => 契約詳細に遷移
         */

        if (["not_acceptable", "unauthorized", "no_company"].includes(data.result.message)) {
          this.$router.replace({
            name: 'DriverMasterTenant',
            query: {error: data.result.message}
          })
        } else if (data.result.message === "many_companies"){
          this.$router.replace({name: 'DriverProviderFreeeCompany'})

        } else {
          this.$router.replace({ name: 'DriverMasterTenant' })
        }
      })
    } else {
      this.$router.push({name: 'DriverMasterTenant', query: { error: "none_params" }})
    }

  },
  methods: {
    /** 外部サービス連携 コールバック処理 */
    ...mapActions("DriverProviderCallback", {
      startCollaboration: "create"
    }),
    ...mapActions("DriverProviderSetting", {
      release: "release",
    }),
  },
}
</script>

<template>
  <div></div>
</template>
